import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class FlagDe extends PureComponent {
    static propTypes = {
        size: PropTypes.number
    };

    static defaultProps = {
        size: 16
    };

    render() {
        const { size } = this.props;
        return (
            <svg id="flag-icon-css-de" viewBox="0 0 640 480" height={size}>
                <path fill="#ffce00" d="M0 320h640v160H0z" />
                <path d="M0 0h640v160H0z" />
                <path fill="#d00" d="M0 160h640v160H0z" />
            </svg>
        );
    }
}

export default withTheme(FlagDe);



// WEBPACK FOOTER //
// ./data/common/iconsvg/FlagDe.js